import { HTTP } from '@/common/utils/http';

export const SchoolActivityCalendarService = {
    getClassDates(schoolId, dateFrom, dateTo) {
        return HTTP.get(`no-auth/schools/${schoolId}/classes/calendar?dateFrom=${dateFrom}&dateTo=${dateTo}`);
    },

    getCampDates(schoolId, dateFrom, dateTo) {
        return HTTP.get(`no-auth/schools/${schoolId}/camps/calendar?dateFrom=${dateFrom}&dateTo=${dateTo}`);
    },

    getAftercareDates(schoolId, dateFrom, dateTo) {
        return HTTP.get(`no-auth/schools/${schoolId}/aftercare/calendar?dateFrom=${dateFrom}&dateTo=${dateTo}`);
    },

    getClassDatesCheckRole(schoolId, dateFrom, dateTo) {
        return HTTP.get(`schools/${schoolId}/classes/calendar?dateFrom=${dateFrom}&dateTo=${dateTo}`);
    },

    getCampDatesCheckRole(schoolId, dateFrom, dateTo) {
        return HTTP.get(`schools/${schoolId}/camps/calendar?dateFrom=${dateFrom}&dateTo=${dateTo}`);
    },

    getAftercareDatesCheckRole(schoolId, dateFrom, dateTo) {
        return HTTP.get(`schools/${schoolId}/aftercare/calendar?dateFrom=${dateFrom}&dateTo=${dateTo}`);
    }
};


// WEBPACK FOOTER //
// ./src/common/services/pages/activity-calendar.service.js